import React from 'react';

import { Route, Switch, Redirect } from 'react-router-dom';
import HomeContainer from 'pages/home/HomeContainer';

import OverviewItineraryContainer from 'pages/itinerary/overview/OverviewItineraryContainer';
import CapetownItineraryContainer from 'pages/itinerary/capetown/CapetownItineraryContainer';
import OkavangoItineraryContainer from 'pages/itinerary/okavango/OkavangoItineraryContainer';
import VicfallsItineraryContainer from 'pages/itinerary/vicfalls/VicfallsItineraryContainer';

// import OverviewGalleryContainer from 'pages/gallery/overview/OverviewGalleryContainer';
import CapetownGalleryContainer from 'pages/gallery/capetown/CapetownGalleryContainer';
import OkavangoGalleryContainer from 'pages/gallery/okavango/OkavangoGalleryContainer';
import VicfallsGalleryContainer from 'pages/gallery/vicfalls/VicfallsGalleryContainer';
import MauritiusGalleryContainer from 'pages/gallery/mauritius/MauritiusGalleryContainer';
import SeychellesGalleryContainer from 'pages/gallery/seychelles/SeychellesGalleryContainer';

// import OverviewDetailsContainer from 'pages/details/overview/OverviewDetailsContainer';
import CapetownDetailsContainer from 'pages/details/capetown/CapetownDetailsContainer';
import OkavangoDetailsContainer from 'pages/details/okavango/OkavangoDetailsContainer';
import VicfallsDetailsContainer from 'pages/details/vicfalls/VicfallsDetailsContainer';
import MauritiusDetailsContainer from 'pages/details/mauritius/MauritiusDetailsContainer';
import SeychellesDetailsContainer from 'pages/details/seychelles/SeychellesDetailsContainer';

const AppRoutes = props =>
    <div className="fullheight">
        <Switch>
            <Route exact path="/" component={HomeContainer} />
            {/* itinerary */}
            <Route
                path="/itinerary-overview"
                component={OverviewItineraryContainer}
            />
            <Route
                path="/itinerary-capetown"
                component={CapetownItineraryContainer}
            />
            <Route
                path="/itinerary-okavango"
                component={OkavangoItineraryContainer}
            />
            <Route
                path="/itinerary-vicfalls"
                component={VicfallsItineraryContainer}
            />
            {/* gallery */}
            {/* <Route
                path="/gallery-overview"
                component={OverviewGalleryContainer}
            /> */}
            <Route
                path="/gallery-capetown"
                component={CapetownGalleryContainer}
            />
            <Route
                path="/gallery-okavango"
                component={OkavangoGalleryContainer}
            />
            <Route
                path="/gallery-vicfalls"
                component={VicfallsGalleryContainer}
            />
            <Route
                path="/gallery-seychelles"
                component={SeychellesGalleryContainer}
            />
            <Route
                path="/gallery-mauritius"
                component={MauritiusGalleryContainer}
            />
            {/* details  */}
            {/* <Route
                path="/details-overview"
                component={OverviewDetailsContainer}
            /> */}
            <Route
                path="/details-capetown"
                component={CapetownDetailsContainer}
            />
            <Route
                path="/details-okavango"
                component={OkavangoDetailsContainer}
            />
            <Route
                path="/details-vicfalls"
                component={VicfallsDetailsContainer}
            />
            <Route
                path="/details-seychelles"
                component={SeychellesDetailsContainer}
            />
            <Route
                path="/details-mauritius"
                component={MauritiusDetailsContainer}
            />

            <Route render={() => <Redirect to="/" />} />
        </Switch>
    </div>;

export default AppRoutes;



// WEBPACK FOOTER //
// ./src/routes/AppRoutes.jsx